import { SET_PAGINATED_CUSTOMERS } from '../actions'

const customersReducer = (state = [], action) => {
  switch (action.type) {
    case SET_PAGINATED_CUSTOMERS: {
      return action.customers
    }
    default:
      return state
  }
}

export default customersReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/customers.js